import { request } from "@/Api";
import { storeBid } from "@/sheet/bidStore";

const useBid = () => {
    const getBid = (id) => {
        request.get(`/bids/${id}`).then((response) => {
            const bid = response.data;
            storeBid(bid);
        });
    };
    return getBid;
};

export { useBid };
